import React from 'react';
import { isLightColor } from '@/lib/helpers';

interface BadgeProps {
  color: string;
  children: React.ReactNode;
}

export const Badge = React.memo(function Badge({ color, children }: BadgeProps) {
  const isVar = color.startsWith("var(");
  const bg = isVar ? "rgba(128,128,128,0.12)" : color;
  const border = isVar ? "rgba(128,128,128,0.2)" : color;
  const textColor = isVar ? "var(--mid)" : isLightColor(color) ? "var(--dark)" : "#FFFFFF";

  return (
    <span
      className="badge"
      style={{
        background: bg,
        border: `1px solid ${border}`,
        color: textColor,
      } as React.CSSProperties}
    >
      {children}
    </span>
  );
});
